import { Redirect, Route } from 'react-router-dom';
import {
  IonApp,
  IonIcon,
  IonLabel,
  IonRouterOutlet,
  IonTabBar,
  IonTabButton,
  IonTabs,
  setupIonicReact,
  useIonRouter
} from '@ionic/react';
import { Plugins } from "@capacitor/core";

import { storefront, storefrontOutline, cube, cubeOutline, notificationsCircleOutline, notificationsCircle, mail, mailOutline, rocketOutline, rocket, home, homeOutline, personOutline, person, newspaper, newspaperOutline, thumbsUp, thumbsUpOutline, logoYoutube, videocam, videocamOutline, flash, flashOutline, aperture, apertureOutline, addCircle, addCircleOutline, settings, settingsOutline } from 'ionicons/icons';
import React, { useState, useContext } from 'react';
import { IonReactRouter } from '@ionic/react-router';

import { LANGUAGE, GetStr } from "./language/Language";
import NServer, { UIElement } from "./components/NServer";
import NotiContext, { NotiProvider } from "./components/NotiContext";

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

import Main from './pages/Main';
import Loader from './pages/Loader';
import Login from './pages/Login';
import Settings from './pages/Settings';
import Media from './pages/Media';
import Studio from './pages/Studio';
import Vote from './pages/Vote';
import AddContent from './pages/AddContent';
import NewChannel from './pages/NewChannel';
import ChannelList from './pages/ChannelList';
import ImgCrop from './pages/ImgCrop';
import ChannelDetail from './pages/ChannelDetail';
import Messages from './pages/Messages';
import ChatMsg from './pages/ChatMsg';
import TokenWallet from './pages/TokenWallet';
import GameInfoPage from './pages/GameInfoPage';
import Games from './pages/Games';
import NtkBuy from './pages/NtkBuy';
import NtkBuyConfirm from './pages/NtkBuyConfirm';
import NtkBuyPass from './pages/NtkBuyPass';
import NtkBuySuccess from './pages/NtkBuySuccess';
import ExchangeRate from './pages/ExchangeRate';
import User from './pages/User';
import BlockList from './pages/BlockList';
import Report from './pages/Report';
import Notification from './pages/Notification';
import Content from './pages/Content';
import Explore from './pages/Explore';
import ForgetPassword from './pages/ForgetPassword';
import Register from './pages/Register';
import ConfirmEmail from './pages/ConfirmEmail';
import ChangeUsername from './pages/ChangeUsername';
import PassCheck from './pages/PassCheck';
import ChangeLang from './pages/ChangeLang';
import MePage from './pages/MePage';
import GamePage from './pages/GamePage';
import AdTest from './pages/AdTest';
import ProfilePic from './pages/ProfilePic';
import ImageView from './pages/ImageView';
import Followers from './pages/Followers';
import UpdateApp from './pages/UpdateApp';
import MantainApp from './pages/MantainApp';
import ChangeChatName from './pages/ChangeChatName';
import RandomChat from './pages/RandomChat';
import Videos from './pages/Videos';
import ImageViewer from './pages/ImageViewer';
import BoostPost from './pages/BoostPost';
import BoostPass from './pages/BoostPass';
import LockSet from './pages/LockSet';
import ChatMsg2 from './pages/ChatMsg2';
import ContentMarket from './pages/ContentMarket';
import Live from './pages/Live';
import NtkExchange from './pages/NtkExchange';
import NtkExConfirm from './pages/NtkExConfirm';
import NtkExchangePass from './pages/NtkExchangePass';
import NtkExSuccess from './pages/NtkExSuccess';
import ShowAddress from './pages/ShowAddress';
import Withdraw from './pages/Withdraw';
import WithdrawConfirm from './pages/WithdrawConfirm';
import WithdrawAmount from './pages/WithdrawAmount';
import WithdrawPass from './pages/WithdrawPass';
import WithdrawSuccess from './pages/WithdrawSuccess';
import BoostReport from './pages/BoostReport';
import GamePost from './pages/GamePost';

/* Theme variables */
import './theme/variables.css';
import './pages/Main.css';

setupIonicReact();

var tabChanged = false;

const App: React.FC = () => {

    const [tab, setTab] = useState("nc_vote");
    
    // main tab was clicked
    const clickTab = (tab : any) => {
        if (tabChanged)
        {
            tabChanged = false;
            return;
        }

        let mainWindow = document.getElementById("main-con-view");
        if (mainWindow != null)
            mainWindow.scrollTo(0, 0);

        let expWindow = document.getElementById("explore-con-view");
        if (expWindow != null)
            expWindow.scrollTo(0, 0);

        let meWindow = document.getElementById("me-con-view");
        if (meWindow != null)
            meWindow.scrollTo(0, 0);

        let marketWindow = document.getElementById("market-con-view");
        if (marketWindow != null)
            marketWindow.scrollTo(0, 0);
    }

    // change the tab
    const changeTab = (tab : string) => {
        tabChanged = true;
        setTab(tab);
    }

    return (
    <IonApp>
        <NotiProvider>
        <IonReactRouter>
            <IonTabs>
                <IonRouterOutlet>
                    <Route path="/mainc" component={Main} />
                    <Route path="/loader" component={Loader} />
                    <Route path="/login" component={Login} />
                    <Route path="/settings" component={Settings} />
                    <Route path="/media" component={Media} />
                    <Route path="/vote" component={Vote} />
                    <Route path="/studio" component={Studio} />
                    <Route path="/add/:type" component={AddContent} />
                    <Route path="/new_channel/:id" component={NewChannel} exact={true} />
                    <Route path="/channel_info/:id" component={ChannelDetail} exact={true} />
                    <Route path="/channel_list/:type" component={ChannelList} exact={true} />
                    <Route path="/imgcrop/:type/:name/:callback/:ax/:ay" component={ImgCrop} exact={true} />
                    <Route path="/chatmsg/:id/:type" component={ChatMsg2} exact={true} />
                    <Route path="/main" component={Messages} />
                    <Route path="/token/:tab" component={TokenWallet} />
                    <Route path="/games" component={Games} />
                    <Route path="/game/:id" component={GameInfoPage} exact={true} />
                    <Route path="/ntkbuy" component={NtkBuy} />
                    <Route path="/ntk_buy_confirm/:amount" component={NtkBuyConfirm} />
                    <Route path="/ntk_buy_pass/:amount" component={NtkBuyPass} />
                    <Route path="/ntkbuysuccess/:usd/:ntoken" component={NtkBuySuccess} />
                    <Route path="/xrate" component={ExchangeRate} />
                    <Route path="/user/:id" component={User} exact={true} />
                    <Route path="/blocklist" component={BlockList} />
                    <Route path="/report/:id/:type" component={Report} exact={true} />
                    <Route path="/noti" component={Notification} />
                    <Route path="/content/:id/:mode" component={Content} exact={true} />
                    <Route path="/market/:id/:mode" component={ContentMarket} exact={true} />
                    <Route path="/explore" component={Explore} />
                    <Route path="/forgetpassword" component={ForgetPassword} />
                    <Route path="/register" component={Register} />
                    <Route path="/confirm_email" component={ConfirmEmail} />
                    <Route path="/change-username" component={ChangeUsername} />
                    <Route path="/pass/:p1/:p2/:api/:return" component={PassCheck} exact={true} />
                    <Route path="/changelang" component={ChangeLang} />
                    <Route path="/me" component={MePage} />
                    <Route path="/gamepage/:id/:p1/:p2" component={GamePage} />
                    <Route path="/ads" component={AdTest} />
                    <Route path="/profilepic/:img" component={ProfilePic} exact={true} />
                    <Route path="/imgview/:img" component={ImageView} exact={true} />
                    <Route path="/followers" component={Followers} />
                    <Route path="/update" component={UpdateApp} />
                    <Route path="/mantain" component={MantainApp} />
                    <Route path="/change_chat_name" component={ChangeChatName} />
                    <Route path="/random_chat" component={RandomChat} />
                    <Route path="/video/:id/:mode" component={Videos} />
                    <Route path="/imgviewer/:img/:index/:content/:type" component={ImageViewer} />
                    <Route path="/boost/:id" component={BoostPost} />
                    <Route path="/boostpass/:content/:amount" component={BoostPass} />
                    <Route path="/lockset" component={LockSet} />
                    <Route path="/golive" component={Live} />
                    <Route path="/ntk_exchange" component={NtkExchange} />
                    <Route path="/ntk_ex_confirm/:amount" component={NtkExConfirm} />
                    <Route path="/ntk_ex_pass/:amount" component={NtkExchangePass} />
                    <Route path="/ntkexsuccess/:usd/:ntoken" component={NtkExSuccess} />
                    <Route path="/address" component={ShowAddress} />
                    <Route path="/withdraw" component={Withdraw} />
                    <Route path="/withdrawpass/:address/:amount" component={WithdrawPass} />
                    <Route path="/withdrawconfirm/:address/:amount" component={WithdrawConfirm} />
                    <Route path="/withdrawsuccess/:address/:amount" component={WithdrawSuccess} />
                    <Route path="/withdraw_amt/:address" component={WithdrawAmount} />
                    <Route path="/boost_report/:id" component={BoostReport} />
                    <Route path="/gamepost/:id" component={GamePost} />

                    <Redirect exact from="/" to="/loader" />
                    <Redirect exact from="/messages" to="/main" />
                    <Redirect exact from="/home" to="/mainc" />
                </IonRouterOutlet>
                
                <IonTabBar id="appTabBar" slot="bottom" onClick={e => clickTab(e)} onIonTabsWillChange={e => changeTab(e.detail.tab)}>
                    <IonTabButton className="main-tab" tab="nc_main" href="/mainc">
                        <IonIcon icon={ tab=="nc_main" ? home : homeOutline } />
                        <IonLabel>{ GetStr(LANGUAGE.TXT_HOME_TAB) }</IonLabel>
                    </IonTabButton>
                    <IonTabButton className="main-tab" tab="nc_media" href="/explore">
                        <IonIcon icon={ tab=="nc_media" ? rocket  : rocketOutline } />
                        <IonLabel>{ GetStr(LANGUAGE.TXT_EXPLORE_TAB) }</IonLabel>
                    </IonTabButton>
                    <IonTabButton className="main-tab" tab="nc_vote" href="/main">
                        <IonIcon icon={ tab=="nc_vote" ? mail : mailOutline } />
                        <IonLabel>{ GetStr(LANGUAGE.TXT_MSG_TAB) }</IonLabel>
                    </IonTabButton>
                    <IonTabButton className="main-tab" tab="nc_noti" href="/token/market">
                        <IonIcon icon={ tab=="nc_noti" ? storefront : storefrontOutline } />
                        <IonLabel>{ GetStr(LANGUAGE.TXT_NOTI_TAB) }</IonLabel>
                    </IonTabButton>
                    <IonTabButton className="main-tab" tab="nc_setting" href="/me">
                        <IonIcon icon={ tab=="nc_setting" ? person : personOutline } />
                        <IonLabel>{ GetStr(LANGUAGE.TXT_SETTING_TAB) }</IonLabel>
                    </IonTabButton>
                </IonTabBar>
            </IonTabs>
        </IonReactRouter>
        </NotiProvider>
    </IonApp>
    );
};

export default App;
